// src/components/filters/FilterDropdown.vue

<template>
  <div class="filter-dropdown">
    <v-flex xs12 class="mb-1">
      <h4 class="gradient-text">{{ label }}</h4>
    </v-flex>
    <v-autocomplete
      outlined
      dense
      :items="items"
      v-model="selected"
      :label="`${count} Available`"
      @change="handleChange"
      return-object
      clearable
    ></v-autocomplete>
  </div>
</template>

<script>
export default {
  name: 'FilterDropdown',
  
  props: {
    label: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, null],
      default: null
    },
    filterType: {
      type: String,
      required: true
    }
  },

  computed: {
    count() {
      return this.items.length;
    },
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },

  methods: {
    handleChange(value) {
      this.$emit('filter-change', {
        filterType: this.filterType,
        value
      });
    }
  }
}
</script>
<style scoped>
.gradient-field :deep(.v-input__slot:hover) {
  border-color: var(--primary-start) !important;
}

.gradient-field :deep(.v-input__slot--focused) {
  border-color: var(--primary-end) !important;
}

.gradient-field :deep(.v-label.v-label--active) {
  color: var(--primary-solid) !important;
}
</style>